import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import TopSideBar from '../../components/TopSideBar'
import TitlebarAction from '../../components/common/TitlebarActions'
import { PADDING_BASE } from '../../assets/Styles'
import PageContainer from '../../components/common/PageContainer'
import TicketEntities from '../../components/EntitiesSettings/TicketEntities'

export default function TicketEntitiesPage({ setBlockScreen }: any) {

  return <>
    <TopSideBar currentSection='ticket-entities' />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="400">
            Administración
          </Typography>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="600">
            Entidades de Ticket
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction title='Entidades de Ticket' />

      <TicketEntities setBlockScreen={setBlockScreen} />

    </PageContainer>
  </>
}